/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 chain2.glb 
*/

import React, { useRef } from 'react'
import { useGLTF, Outlines } from '@react-three/drei'
import * as THREE from 'three'

const BASE = import.meta.env.BASE_URL

export default function Model(props) {
  const { nodes, materials } = useGLTF(`${BASE}biteback/models/chain2.glb`)
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Torus.geometry} castShadow receiveShadow>
        <meshStandardMaterial
          color={'white'}
          metalness={0.0}
          roughness={0.35}
          flatShading={false}
          vertexColors={false}   // ignore any vertex colors baked into the glb
          toneMapped={true}      // or =false if your tone mapping is washing colors out
          transparent={true}
        />
              <Outlines thickness={0.3} color={'#000000'} screenspace/>
      </mesh>
    </group>
  )
}

useGLTF.preload(`${BASE}biteback/models/chain2.glb`)
